import { tv } from "@ui/lib/tv";
import { TextFieldTextArea, type TextFieldTextAreaProps } from "./TextField";

const autoGrowField = tv({
  base: "autogrow-field max-h-[8lh] min-h-[1lh] overflow-y-auto",
});

export interface AutoGrowTextAreaProps extends Omit<TextFieldTextAreaProps, "value"> {
  /** The field's current value. Also mirrored into the sizing fallback, which measures a copy of
   *  the text rather than the field itself — so a stale value here means a stale height in
   *  browsers without `field-sizing`. Keep it the same state the parent `TextField` is driven by. */
  value: string;
  /** Classes for the sizing wrapper. Padding, type and height bounds go here rather than on the
   *  field: the wrapper's box is the grid cell that the field and its measuring copy both fill. */
  className?: string;
}

/**
 * A textarea that grows with its content between a one-line floor and an eight-line ceiling, then
 * scrolls. Docked at the bottom of a column it appears to grow upward.
 *
 * Must be rendered inside a `TextField`, which owns value and change handling.
 */
export function AutoGrowTextArea({ className, value, ...props }: AutoGrowTextAreaProps) {
  return (
    <div className={autoGrowField({ className })} data-replicated-value={value}>
      <TextFieldTextArea {...props} />
    </div>
  );
}
